import React, { Component } from 'react';
import $ from 'jquery';

import AdminLayout from './../layout';

import { postajob  } from './../../../API/FetchCall';
//import { Editor } from '@tinymce/tinymce-react';

import 'react-notifications/lib/notifications.css';
import {NotificationContainer, NotificationManager} from 'react-notifications';

import Slider from 'react-rangeslider'
import 'react-rangeslider/lib/index.css'

class Addothercourse extends Component {

  constructor(props) {
    super(props);
    this.state = {
      logged: localStorage.getItem("authentication"),
      auth_data: JSON.parse(localStorage.getItem("user_data")),
      category_data: [], collapse: 0, modalReply: false,
      current_comment: '', current_rid: 0, current_eid: '',
      PER_PAGE:15,
      total:0,
      loading:true,
      list:[]
    }

    this.cancelPop = this.cancelPop.bind(this);
    this.handleChange = this.handleChange.bind(this);

  }
 

  componentDidMount() {

          var THIS = this;
  
   

  }


  handleChangeHorizontal = value => {
    this.setState({
      salary_range_forthisjob: value
    })
  };


  cancelPop(){
    this.setState({blockinstopenmodal:false});
  }


  handleChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });

    if(e.target.value=='Other'){
      this.setState({[e.target.name+"_other_disabled"]:false});
    }
     
  };  
 
  handleSubmit =(e) =>{

    let req = JSON.stringify({
        name:this.state.name,
        url: this.state.url
    })
    
    postajob(req).then((response) => {
      
      if(response.status==1){
            
        NotificationManager.success('Posted job successfully', 'Post a job');

      }else{
            
        NotificationManager.error('Error posting a job', 'Post a job');
      }

    });
}

 
  
 
  render() {
 const {value, suggestions, pickedones} = this.state;

 
        return (
            <React.Fragment>
                <AdminLayout>
                    
            <div class="col-12 grid-margin">
            
              <div class="card">
                    <div class="card-body">

                     
                  <h4 class="card-title">Other Course - Add</h4>
                 
                    <div class="postajobform wc">

<div class="formgroup end_date_option" id="end_date_option">
<label for="exampleInputPassword1">Name </label>
<input type="text" class="form-control forminputcls" id="name" name="name"   onChange={this.handleChange}/>
</div> 

<div class="formgroup end_date_option" id="end_date_option">
<label for="exampleInputPassword1">URL </label>
<input type="text" class="form-control forminputcls" id="url" name="url"   onChange={this.handleChange}/>
</div> 


<div class="formgroup text-center paddingtop20">
<button type="button" name="postajob" class="btn btn-primary" onClick={this.handleSubmit}>Submit</button>
</div> 

</div>


                   </div>
              </div>

            </div> 
            
            <NotificationContainer/>


                </AdminLayout>
            </React.Fragment>
        )
    }

}

export default Addothercourse;


// WEBPACK FOOTER //
// ./src/components/bewise/wiseconnect/addothercourse.jsx